import React from 'react';
import PropTypes from 'prop-types';
import EnhancedTable from '../../Shared/EnhancedTable/EnhancedTable';
import styles from './CaseManagerGrid.style';
import { withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';

const CaseManagerGrid = props => {
	const { classes, fetchRowsPromise } = props;

	// link component
	function OrderNoLink(props) {
		const { classes, row } = props;

		return (
			<Link className={classes.orderLink} to={`/cases/${row['id']}`}>
				{row['orderNumber']}
			</Link>
		);
	}

	OrderNoLink.propTypes = {
		classes: PropTypes.object.isRequired,
		row: PropTypes.shape({
			id: PropTypes.string.isRequired, // GUID from C#
			orderNumber: PropTypes.string.isRequired // String from C#
		}) // Not required here because it's provided by EnhancedTable at runtime
	};

	const customCells = {
		// the name of the custom cell must be equal to the column id
		orderNumber: <OrderNoLink classes={classes} />
	};

	const headCells = [
		{ id: 'orderNumber', label: 'Order No.', width: '12%' },
		{ id: 'office', label: 'Shared By Office', width: '20%' },
		{ id: 'contact', label: 'Main Contact', width: '12%' },
		{ id: 'claimantName', label: 'Claimant Name', width: '12%' },
		{ id: 'caseName', label: 'Case Name', width: '20%' },
		{ id: 'claimNumber', label: 'Claim No.', width: '12%' },
		{ id: 'firmFileNumber', label: 'Firm File No.', width: '12%' }
	];
	return (
		<EnhancedTable
			headCells={headCells}
			rowsPerPageOptions={[]}
			useDbPagination={true}
			customCells={customCells}
			showPagination
			fetchRowsPromise={fetchRowsPromise}
			rowKey="id"
		/>
	);
};

CaseManagerGrid.propTypes = {
	classes: PropTypes.object.isRequired,
	fetchRowsPromise: PropTypes.func.isRequired
};

export default withStyles(styles)(CaseManagerGrid);
